import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';

interface ItemType {
    img: [string, string];
    name: string;
    text: string;
    memo: string;
}
const J: React.FC = () => {
    const { t } = useLang('d3u');
    const items: ItemType[] = [
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1760925330101/10_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760925329434/10_1_M.jpg'],
            name: t('J_item1_name'),
            text: t('J_item1_text'),
            memo: t('J_item1_memo'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1760925330443/10_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760925329618/10_2_M.jpg'],
            name: t('J_item2_name'),
            text: t('J_item2_text'),
            memo: t('J_item2_memo'),
        },
    ];

    return (
        <section className={`${css.section} D3U-J GtmModuleData-section`} id="D3U-J" data-section-id={'D3U-J'} data-section-id2={t('J_title')}>
            <div className="info">
                <p className="label">{t('J_label')}</p>
                <p className="title">{t('J_title')}</p>
            </div>
            <ul className="items">
                {items.map((item: ItemType, k: number) => (
                    <li className="item" key={k}>
                        <div className="img">
                            <EcoImg pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} />
                        </div>
                        <div className="msg">
                            <p className="name">{item.name}</p>
                            <p className="text">{item.text}</p>
                            <p className="memo">{item.memo}</p>
                        </div>
                    </li>
                ))}
            </ul>
            <p className="tip">{t('J_tip')}</p>
        </section>
    );
};

export default J;
